// vendor
import { defineComponent, computed, PropType, watch, ref } from "@vue/composition-api";
// project
import * as SessionAPI from "@/services/api/sessions";
import { Dictionary } from "@/utils/types";
// local
import * as ItemComponents from "./ItemComponents";
import { FormItem, DataChannel } from "./types";
import AlertBox from "../vue/alert-box.vue";

type ItemComponent = {
	isValid?:() => boolean,
	getChannels?:(prefix:string) => DataChannel<any>[]
};

export const RunFormItem = defineComponent({
	emits:[ "input", "touch" ],
	props:{
		cacheKey:{
			type:String,
			required:true
		},
		value:{
			type:null
		},
		config:{
			type:Object as PropType<FormItem<any>>,
			required:true
		},
		cache:{
			type:Object as PropType<Dictionary<any>>,
			required:true
		}
	},
	components:{
		AlertBox
	},
	setup(props, context){

		const component = ref<ItemComponent>();
		
		const sessionId = computed(() => context.root.$route.params["sessionId"]);

		const val = computed({
			get:() => props.value,
			set:v => context.emit("input", v)
		});

		const name = computed(() => props.config.name);
		const type = computed(() => props.config.type);
		const hideName = computed(() => props.config.hideName);
		const itemComponent = computed(() => (ItemComponents as any)[props.config.type]);

		watch(() => props.value, (v) => {
			if(sessionId.value){
				SessionAPI.cacheSessionValue(sessionId.value, props.cacheKey, v);
			}
			setTimeout(() => {
				context.emit("touch", { id:props.config.id });
			},1);
		});

		const getChannels = (prefix:string):DataChannel<any>[] => {
			const p = component.value;
			if(!p){ return []; }
			const c = p.getChannels ? p.getChannels(`${prefix}/${props.config.id}`) : [];
		
			// const unsaved = c.filter(ch => {
			// 	const cached = props.cache[`${ch.key}.saved`];
			// 	if(cached === undefined){ return true; }
			// 	if(cached === ch.data){ return false; }
			// 	return true;
			// });

			// unsaved.forEach(ch => {
			// 	props.cache[`${ch.key}.saved`] = ch.data;
			// 	if(sessionId.value){
			// 		SessionAPI.cacheSessionValue(sessionId.value, `${ch.key}.saved`, ch.data);
			// 	}
			// });
			// return unsaved;
			return c;
		};

		const isValid = () => {
			if(props.config.optional){ return true; }
			let c = component.value;
			if(!c){ return false; }
			return c.isValid ? c.isValid() : true;
		};

		return {
			name,
			type,
			hideName,
			component,
			val,
			itemComponent,
			isValid,
			getChannels
		};
	}
});